import { Component, Input } from '@angular/core';

@Component({
	standalone: false,
	selector: 'qe-check-icon',
	templateUrl: './check-icon.component.html',
})
export class CheckIconComponent {
	@Input() public readonly variableName?: string = 'brandPrimary';

	constructor() {}
}
